import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { PIN_ALPHABET } from 'src/app/shared/constants/map-pin.constant';
import { IStopover } from 'src/app/core/types/interfaces/trip-elements.interface';

import { AttractionInfoComponent } from 'src/app/shared/used-components/attraction-info/attraction-info.component';

@Component({
    selector: 'app-stopover-card',
    templateUrl: './stopover-card.component.html',
    styleUrls: ['./stopover-card.component.scss'],
    imports: [NgxSkeletonLoaderModule, MatIconModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StopoverCardComponent {
  @Input({ required: true }) stopover: IStopover;
  @Input({ required: true }) stopoverIndex: number = 0;
  @Input() isSelected: boolean = false;
  @Input() distance: string = '';

  @Output() onSelect: EventEmitter<IStopover> = new EventEmitter<IStopover>();
  @Output() onUnselect: EventEmitter<IStopover> = new EventEmitter<IStopover>();

  public readonly pinAlphabet = PIN_ALPHABET;
  public readonly eSvgIcons = ESvgIcons;

  #matDialog: MatDialog = inject(MatDialog);

  public get location(): string {
    const parts = this.stopover.link.replace(/^\/|\/$/g, '').split('/');

    if (parts.length < 2) {
      return '';
    }

    const [country, region] = parts.slice(0, 2);

    const formattedParts = [country, region].map((part) =>
      part.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()),
    );

    return formattedParts.join(', ');
  }

  public onOpenAttractionDialog(): void {
    const place: IStopover = this.stopover;
    this.#matDialog.open(AttractionInfoComponent, {
      width: '592px',
      maxWidth: '96vw',
      maxHeight: '96%',
      data: {
        title: place.name,
        imageUrl: place.imageUrl,
        description: place.description,
      },
    });
  }
}
